import React from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { getFeatureToggle, getLoanApplication } from '../../selectors';
import { getQuotes, selectOfferFormSubmitted } from '../../actions/loanApplicationActions';
import { displayErrors } from '../../actions';
import QuotesForm from '../LoanApplication/QuotesForm/quotesForm';
import ProgressBar from '../progress.bar';
import LoanApplicationHeader from '../LoanApplication/LoanApplicationHeader/loanApplicationHeader';
import moneyFormatter from 'money-formatter';
import PropTypes from 'prop-types';

export class SelectOfferPage extends React.Component {

  componentDidMount = () => {
    this.props.getQuotes(this.props.applicationId, this.props.quoteId);
  };

  render() {
    const { applicationId, quoteId, quotes, cylEligible, firstName, loanAmount, status, cl_update_disclosure_and_header_for_cyl_eligible } = this.props;

    if (!applicationId || !quoteId) {
      return (<Redirect to="/apply"/>);
    }

    if (status && status === 'DECLINED') {
      return (<Redirect to="/apply/decision"/>);
    }

    if (quotes) {
      return (
        <article>
          { cl_update_disclosure_and_header_for_cyl_eligible && cylEligible ?
            <LoanApplicationHeader>
              <ul>
                <li>
                  <h2 className="headline-font">
                    <div className="pb-2">
                    Congratulations, <span className="font-weight-normal">{firstName}</span>!
                    </div>
                    <div>
                    You’re <span className="font-weight-normal">pre-qualified</span> for
                     a <span id="loan-amount" className="font-weight-normal">{moneyFormatter.format('USD', quotes[0].loanAmount.amount, 0)}</span> loan.
                    </div>
                  </h2>
                </li>
              </ul>
            </LoanApplicationHeader>
            :
            <LoanApplicationHeader title="Your loan details">
              <ul>
                <li>
                  <h2 id="loan-amount">{moneyFormatter.format('USD', loanAmount, 0)}</h2>
                  <p>Requested amount</p>
                </li>
              </ul>
            </LoanApplicationHeader>
          }
          <section id="quotes" className="cyr-step">
            <header>
              <ProgressBar step="quotes"/>
            </header>

            <QuotesForm cylEligible={cylEligible} quotes={quotes} onSubmit={this.props.selectOfferFormSubmitted} displayErrors={this.props.displayErrors} cl_update_disclosure_and_header_for_cyl_eligible={this.props.cl_update_disclosure_and_header_for_cyl_eligible} />

            <footer>
              <p>
                <i className="material-icons">thumb_up</i> Checking your rate won't affect your credit score.
              </p>
            </footer>
          </section>
        </article>);
    }
    return null;
  }
}

SelectOfferPage.propTypes = {
  getQuotes: PropTypes.func.isRequired,
  selectOfferFormSubmitted: PropTypes.func.isRequired,
  displayErrors: PropTypes.func.isRequired,
  applicationId: PropTypes.string.isRequired,
  quoteId: PropTypes.string.isRequired,
  status: PropTypes.string,
  quotes: PropTypes.array
};

const mapStateToProps = (state) => {
  const application = getLoanApplication(state);
  return {
    applicationId: application.applicationId,
    quoteId: application.quoteId,
    status: application.status,
    quotes: application.quotes,
    firstName: application.firstName,
    cylEligible: application.cylEligible,
    loanAmount: application.loanAmount,
    cl_update_disclosure_and_header_for_cyl_eligible: getFeatureToggle(state, "cl_update_disclosure_and_header_for_cyl_eligible")
  };
};
const mapDispatchToProps = { getQuotes, selectOfferFormSubmitted, displayErrors };

export default connect(mapStateToProps, mapDispatchToProps)(SelectOfferPage);
